var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-data-editor',{attrs:{"id":_vm.id,"title":"Редактирование типа упаковки","resource":"package-types","elements":_vm.elements,"add-message":"Тип упаковки добавлен","edit-message":"Тип упаковки изменен","without-remove":_vm.isAdmin ? false : true}})
}
var staticRenderFns = []

export { render, staticRenderFns }